
import React, { Component}  from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from "@material-ui/core/Button";
import SaveOutlinedIcon from '@material-ui/icons/SaveOutlined';
import {YellowButton} from "../../ui/Button";
import FormOrder from "./FormOrder";


export default class FormDialogWrapper extends Component {

  constructor(props) {
    super(props);

    this.state = {
      showConfirmDialog: false,
      dialogContent: null
    }
  }

  handleSubmit = (e, formContext, redirect = true) => {
    const { onPostSave } = this.props;
    let messages = [];

    if (formContext.context.has_contract === false) {
      messages.push('У контрагента отсутствует договор с перевозчиком');
    }

    if (messages.length > 0) {
      this.setState({
        showConfirmDialog: true,
        dialogContent: <>
          <ul>
          {messages.map((message, index) => <li key={index}>{message}</li>)}
          </ul>
        </>
      })
    }
    else {
      formContext.handleSubmit(e, redirect ? onPostSave : undefined);
    }
  }

  closeConfirmDialog = () => {
    this.setState({
      showConfirmDialog: false
    }, () => this.setState({
      dialogContent: null
    }))
  }

  render() {
    const { formContext, buttonLabel, onPostSave } = this.props;
    const { showConfirmDialog, dialogContent } = this.state;
    const { loading } = formContext;
    return (
      <>
        <div className={'mb-30'}>
          <YellowButton
            size={'large'}
            disabled={loading}
            onClick={(e) => this.handleSubmit(e, formContext)}
          >
            {buttonLabel}
          </YellowButton>

          <Button
            size={'large'}
            disabled={loading}
            variant={'outlined'}
            onClick={(e) => this.handleSubmit(e, formContext, false)}
            className={'ml-10'}
            style={{
              minHeight: '42px'
            }}
          >
            <SaveOutlinedIcon />
          </Button>
        </div>

        <FormOrder />

        <div className={'mt-30'}>
          <YellowButton
            size={'large'}
            disabled={loading}
            onClick={(e) => this.handleSubmit(e, formContext)}
          >
            {buttonLabel}
          </YellowButton>

          <Button
            size={'large'}
            disabled={loading}
            variant={'outlined'}
            onClick={(e) => this.handleSubmit(e, formContext, false)}
            className={'ml-10'}
            style={{
              minHeight: '42px'
            }}
          >
            <SaveOutlinedIcon />
          </Button>
        </div>

        <Dialog
          open={showConfirmDialog}
          onClose={() => this.closeConfirmDialog()}
        >
          <DialogTitle>Обнаружены следующие ошибки</DialogTitle>
          <DialogContent>
            <DialogContentText component={'div'}>
              {dialogContent}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => this.closeConfirmDialog()} color="primary">
              Отмена
            </Button>
            <Button
              onClick={(e) => {
                formContext.handleSubmit(e, onPostSave);
                this.closeConfirmDialog();
              }}
              color="primary"
              autoFocus
            >
              Все равно сохранить
            </Button>
          </DialogActions>
        </Dialog>
      </>
    )
  }
}
